import { NgModule } from '@angular/core';

import { CollectionTypeToggleForButtonDropDownModule } from './forButtonDropDown';
import { CollectionTypeToggleForInlineModule } from './forInline';
import { CollectionTypeToggleForLinkDropDownModule } from './forLinkDropDown';

import { CollectionTypeToggleTypesComponent } from './collection-type-toggle-types.shared.component';

const toExport: any[] = [
    CollectionTypeToggleForButtonDropDownModule,
    CollectionTypeToggleForInlineModule,
    CollectionTypeToggleForLinkDropDownModule,
];

@NgModule({
    declarations: [
        CollectionTypeToggleTypesComponent
    ],
    imports: [
        ...toExport
    ],
    exports: [
        ...toExport,
        CollectionTypeToggleTypesComponent,
    ],
})
export class CollectionTypeToggleTypesModule { }
